import React, { Component, useEffect, useState } from 'react';
import { HashRouter, Route, Switch, BrowserRouter } from 'react-router-dom';
import fire from './fire';
import './scss/style.scss';
import { useHistory } from "react-router-dom";
export const TokenContext = React.createContext();



const loading = (
  <div style={{ backgroundColor: "rgba(135, 206, 235, 0.4)", height: "2000px", position: "fixed", display: "flex", width: "100%" }} >
    <div style={{
      backgroundImage: "url(images/Flotas_Logo2-02-removebg-preview.png)", width: "500px",
      height: "300px",
      position: "relative",
      backgroundSize: "cover",
      margin: "100px auto"
    }}></div>
  </div>
);
const loading2 = (
  <div style={{ backgroundColor: "rgba(135, 206, 235, 0.4)", height: "2000px", position: "fixed", display: "flex", width: "100%" }} >
    <div className="container" style={{}}>
      <h1 style={{ margin: "100px auto" }}>Flotas</h1>
      <h4 style={{ margin: "0px auto" }}>Hey, we are still opening up. Stay tuned!</h4>
    </div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));
const Home = React.lazy(() => import('./containers/Home'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));

function App() {

  const [shopperCards, setShopperCards] = useState([])
  const [travelerCards, setTravelerCards] = useState([])
  const [shopperTitle, setShopperTitle] = useState([])
  const [travelerTitle, setTravelerTitle] = useState([])
  const [webFeatures, setWebFeatures] = useState([])
  const [loading1, setLoading1] = useState(false)


  useEffect(() => {
    fire.firestore().collection("homeCards")
      .get().then((data) => {
        setTravelerCards(data.docs)
        fire.firestore().collection("shopperCards")
          .get().then((data) => {
            setShopperCards(data.docs)
            fire.firestore().collection("generalHomeContent").doc("forShopperTitle")
              .get().then((data) => {
                setShopperTitle(data.data().body)
                fire.firestore().collection("generalHomeContent").doc("forTravelerTitle")
                  .get().then((data) => {
                    setTravelerTitle(data.data().body)
                    fire.firestore().collection("webFeatures")
                      .get().then((data) => {
                        setWebFeatures(data.docs)
                        setLoading1(true)
                      })

                  })
              })
          })
      })


    // setCardsData(shopperCards)




  }, [])


  async function refreshToken(token) {
    const requestOptions = {
      method: 'POST',
      headers: { "Content-Type": 'application/json', },
      body: JSON.stringify({ "grant_type": "refresh_token", "refresh_token": token })

    };
    let api;
    try {
      api = await fetch('https://securetoken.googleapis.com/v1/token?key=AIzaSyCSy2wf4Ox56_e_S50S5PBqS2usJBI8md0', requestOptions)
      const data = await api.json();
      console.log(data)
      return data


    }
    catch (e) {
      console.log("Error: ", e);
      return false
    }
  }

  async function verifyToken(token) {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'authorization': token },

    };
    let api;
    try {
      api = await fetch('https://us-central1-flatsdatabase-dbcf5.cloudfunctions.net/verifyToken', requestOptions)
      const data = await api.json();
      console.log(data.token)
      return data.token


    }
    catch (e) {
      console.log("Error: ", e);
      return false
    }
  }

  const history = useHistory();


  async function signOut() {
    fire.auth().signOut()
    fire.firestore().collection("tokens")
      .where("email", "==", localStorage.getItem("email"))
      .where("device", "==", "web").get().then((loggedOrNot) => {
        if (loggedOrNot.docs.length > 0) {
          fire.firestore().collection("tokens").doc(loggedOrNot.docs[0].id).delete()
        }
      })
    localStorage.setItem("email", "");
    localStorage.setItem("token", "");
    localStorage.setItem("uid", "")
    localStorage.setItem("image", "")
  }
  if (true) {
    return (<div style={{ backgroundColor: "rgba(135, 206, 235, 0.4)", height: "2000px", position: "fixed", display: "flex", width: "100%" }} >
      <div style={{
        height: "300px",
        position: "relative",
        backgroundSize: "cover",
        margin: "100px auto"
      }}>
        <div style={{
          display: "flex", margin: "0px auto", position: "relative", width: "200px"
        }}>
          <div style={{
            backgroundImage: "url(images/HandWave-removebg-preview.png)", width: "100px",
            height: "100px",
            position: "relative",
            backgroundSize: "cover",
          }}></div>
          <div style={{
            backgroundImage: "url(images/Flotas_Logo2-02-removebg-preview.png)", width: "100px",
            height: "70px",
            position: "relative",
            backgroundSize: "cover",
            marginTop:"15px"
            // margin: "0px auto"
          }}></div>
        </div>
        <h4 style={{
          margin: "0px auto", fontSize: "35px",
        }}>Hey, we are still opening up. Stay tuned!</h4>
      </div>
    </div>)
  }
  if (loading1 == false) {
    return loading
  }
  else {
    return (
      <TokenContext.Provider value={{ verifyToken, signOut, history, refreshToken, webFeatures, shopperCards, travelerCards, shopperTitle, travelerTitle }}>
        <HashRouter>
          <React.Suspense fallback={loading}>
            <Route path="/admin" name="admin" render={props => <TheLayout {...props} />} />
            <Route exact path="/login" name="Login Page" render={props => <Login {...props} />} />
            <Route exact path="/register" name="Register Page" render={props => <Register {...props} />} />
            <Route exact path="/404" name="Page 404" render={props => <Page404 {...props} />} />
            <Route exact path="/500" name="Page 500" render={props => <Page500 {...props} />} />
            <Route exact path="/" name="Home" render={props => <Home {...props} />} />
          </React.Suspense>
        </HashRouter>
      </TokenContext.Provider>
    );
  }

}

export default App;
